export default __webpack_public_path__ + "static/media/morocco-square.98a1c800.png";